// `createServiceClient` — the only place that picks an implementation.
// Admin-web wants the fetch transport; desktop main wants the in-process
// transport. Tests can pick either.
//
// This factory exists so consumers don't have to `instanceof` against
// concrete classes; they always depend on the `ServiceClient` interface.

import { HttpServiceClient, type HttpServiceClientOptions } from './http-client.js';
import { InProcessServiceClient, type InProcessServiceClientDeps } from './in-process-client.js';
import type { ServiceClient } from './index.js';

export type ServiceClientTransport =
  | { kind: 'http'; options: HttpServiceClientOptions }
  | { kind: 'in-process'; deps: InProcessServiceClientDeps };

export type ServiceClientOptions = ServiceClientTransport;

export function createServiceClient(options: ServiceClientOptions): ServiceClient {
  switch (options.kind) {
    case 'http':
      return new HttpServiceClient(options.options);
    case 'in-process':
      return new InProcessServiceClient(options.deps);
  }
}
